export const HOME_PAGE = "HOME_PAGE";
export const SIGN_UP = "SIGN_UP";
